import { AlertIcon, CheckIcon, InfoIcon, StopIcon } from "../../../assets/icons"

import { BUTTON_COLORS } from "../button/config"

export const TOAST_VARIANT = {
  error: "error",
  warning: "warning",
  success: "success",
  info: "info",
} as const

export type ToastVariant = keyof typeof TOAST_VARIANT

export const TOAST_ICONS = {
  [TOAST_VARIANT.info]: InfoIcon,
  [TOAST_VARIANT.error]: StopIcon,
  [TOAST_VARIANT.warning]: AlertIcon,
  [TOAST_VARIANT.success]: CheckIcon,
} as const

export type ToastIcons = keyof typeof TOAST_ICONS

export const TOAST_BUTTON_COLORS = {
  [TOAST_VARIANT.success]: BUTTON_COLORS.SUCCESS,
  [TOAST_VARIANT.warning]: BUTTON_COLORS.WARNING,
  [TOAST_VARIANT.error]: BUTTON_COLORS.ERROR,
  [TOAST_VARIANT.info]: BUTTON_COLORS.PRIMARY,
} as const
